<template>
  <div>
    <v-container fluid>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'today'"
      ></date-filter>
    </v-container>
    <v-container>
      <v-data-table
        :loading="loading"
        hide-actions
        :headers="headers"
        :items="items"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td
            @click="showModal({ type: 'admin', value: props.item.adminname })"
            class="text-xs-left astonadminname"
          >
            {{ props.item.adminname }}
          </td>
          <td
            @click="showModal({ type: 'page', value: props.item.pageid })"
            class="text-xs-left astonpagename"
          >
            {{ astonpagename[props.item.pageid] ? astonpagename[props.item.pageid].name : '-' }}
          </td>
          <td class="text-xs-left">
            <template v-if="props.item.average_time">
              {{
                props.item.average_time.hasOwnProperty('hours')
                  ? `${props.item.average_time.hours} hours ${props.item.average_time.minutes} minutes`
                  : props.item.average_time.hasOwnProperty('minutes')
                  ? `${props.item.average_time.minutes} minutes ${props.item.average_time.seconds} seconds`
                  : `${props.item.average_time.seconds} seconds`
              }}
            </template>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" max-width="490">
        <v-card>
          <div class="text-xs-right">
            <v-btn @click="dialog = false" icon>
              <em class="fas fa-times" />
            </v-btn>
          </div>
          <v-card-title
            :style="`padding-top: 0;font-size: 1.2em;color: ${$vuetify.theme.primary}`"
            >{{ dialogdata.header }}</v-card-title
          >
          <v-card-text>
            <v-data-table
              hide-actions
              :headers="dialogdata.headers"
              :items="dialogdata.items"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td class="text-xs-left">
                  {{
                    dialogdata.type == 'admin'
                      ? astonpagename[props.item.pageid]
                        ? astonpagename[props.item.pageid].name
                        : '-'
                      : props.item.adminname
                  }}
                </td>
                <td class="text-xs-left">
                  <template v-if="props.item.average_time">
                    {{
                      props.item.average_time.hasOwnProperty('hours')
                        ? `${props.item.average_time.hours} hours ${props.item.average_time.minutes} minutes`
                        : `${props.item.average_time.minutes} minutes ${props.item.average_time.seconds} seconds`
                    }}
                  </template>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="dialog = false">Disagree</v-btn>
            <v-btn color="primary" flat @click.native="dialog = false">Agree</v-btn>
          </v-card-actions>-->
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import DateFilter from './DateFilter.vue'
import moment from 'moment'
import api from '@/api'

export default {
  components: {
    DateFilter
  },
  data() {
    return {
      dialog: false,
      loading: true,
      dialogdata: {
        header: '',
        type: '',
        headers: [],
        items: []
      },
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      headers: [
        { text: 'ชื่อแอดมิน', value: 'adminname', align: 'center' },
        { text: 'ชื่อเพจ', value: 'pageid' },
        { text: 'เวลาเฉลี่ยในการตอบกลับ', value: 'average_time' }
      ],
      items: []
    }
  },
  computed: {
    astonpagename() {
      return this.$aston.astonpagename
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    showModal(data) {
      this.dialog = true
      this.dialogdata.type = data.type
      if (data.type == 'admin') {
        this.dialogdata.header = data.value
        this.dialogdata.headers = [
          { text: 'ชื่อเพจ', value: 'pageid' },
          { text: 'เวลาเฉลี่ยในการตอบกลับ', value: 'average_time' }
        ]
        this.dialogdata.items = this.items.filter((el) => el.adminname == data.value)
      } else {
        this.dialogdata.header = this.astonpagename[data.value].name
        this.dialogdata.headers = [
          { text: 'ชื่อแอดมิน', value: 'adminname' },
          { text: 'เวลาเฉลี่ยในการตอบกลับ', value: 'average_time' }
        ]
        this.dialogdata.items = this.items.filter((el) => el.pageid == data.value)
      }
    },
    getData() {
      var vm = this
      this.loading = true
      var data = { datefrom: this.selectedDate.start, dateto: this.selectedDate.end }
      api.astonaveragespeedofanswer(data, (err, response) => {
        vm.items = response.data
        this.loading = false
      })
    },
    onDateChanged() {
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.astonadminname {
  cursor: pointer !important;
}
.astonpagename {
  cursor: pointer;
}
.astonadminname:hover {
  color: #ff846d !important;
}
.astonpagename:hover {
  color: #ff846d;
}
</style>



// WEBPACK FOOTER //
// src/components/view/dashboard/AstonDashboardAdminTiming.vue